<div class="invoice-details" *ngIf="invoiceData">
    <div class="header-sections">
        <div class="section totals">
            <h4>Financial Details</h4>
            <table class="totals-table">
                <tr>
                    <td><strong>Sub Total:</strong></td>
                    <td>
                        <span class="tooltip-container" [attr.data-label]="invoiceData.sub_total.label">
                            {{invoiceData.sub_total.value | currency:(invoiceData.sub_total.currency ||
                            'USD'):'symbol':'1.2-2'}}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td><strong>VAT:</strong></td>
                    <td>
                        <span class="tooltip-container" [attr.data-label]="invoiceData.vat.label">
                            {{invoiceData.vat.value | currency:(invoiceData.vat.currency || 'USD'):'symbol':'1.2-2'}}
                        </span>
                    </td>
                </tr>
                <tr class="total">
                    <td><strong>Total Amount:</strong></td>
                    <td>
                        <span class="tooltip-container" [attr.data-label]="invoiceData.total_amount.label">
                            {{invoiceData.total_amount.value | currency:(invoiceData.total_amount.currency ||
                            'USD'):'symbol':'1.2-2'}}
                        </span>
                    </td>
                </tr>
            </table>
        </div>

        <div class="section invoice-info">
            <h4>Invoice Information</h4>
            <table class="info-table">
                <tr>
                    <td><strong>Invoice Number:</strong></td>
                    <td><span class="tooltip-container"
                            [attr.data-label]="invoiceData.invoice_number.label">{{invoiceData.invoice_number.value}}</span>
                    </td>
                </tr>
                <tr>
                    <td><strong>Date:</strong></td>
                    <td><span class="tooltip-container"
                            [attr.data-label]="invoiceData.date.label">{{invoiceData.date.value}}</span></td>
                </tr>
                <tr>
                    <td><strong>Due Date:</strong></td>
                    <td><span class="tooltip-container"
                            [attr.data-label]="invoiceData.due_date.label">{{invoiceData.due_date.value}}</span></td>
                </tr>
                <tr>
                    <td><strong>Order Number:</strong></td>
                    <td><span class="tooltip-container"
                            [attr.data-label]="invoiceData.haqtza.label">{{invoiceData.haqtza.value}}</span></td>
                </tr>
            </table>
        </div>
    </div>

    <div class="section parties">
        <div class="vendor-info">
            <h4>Vendor Details</h4>
            <p><strong>Name:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.vendor_name.label">{{invoiceData.vendor_name.value}}</span></p>
            <p><strong>Address:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.vendor_address.label">{{invoiceData.vendor_address.value}}</span></p>
            <p><strong>Phone:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.vendor_phone.label">{{invoiceData.vendor_phone.value}}</span></p>
            <p><strong>Email:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.vendor_email.label">{{invoiceData.vendor_email.value}}</span></p>
            <p><strong>Tax ID:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.tax_id.label">{{invoiceData.tax_id.value}}</span></p>
        </div>

        <div class="buyer-info">
            <h4>Buyer Details</h4>
            <p><strong>Name:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.buyer_name.label">{{invoiceData.buyer_name.value}}</span></p>
            <p><strong>Address:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.buyer_address.label">{{invoiceData.buyer_address.value}}</span></p>
            <p><strong>Email:</strong> <span class="tooltip-container"
                    [attr.data-label]="invoiceData.buyer_email.label">{{invoiceData.buyer_email.value}}</span></p>
        </div>
    </div>
    <div class="section items">
        <h4>Invoice Items</h4>
        <table class="items-table" *ngIf="invoiceData.items?.length">
            <thead>
                <tr>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Unit Price</th>
                    <th>Total Price</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of invoiceData.items">
                    <td>{{item.description}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.unit_price | currency:(item.currency || 'USD'):'symbol':'1.2-2'}}</td>
                    <td>{{item.total_price | currency:(item.currency || 'USD'):'symbol':'1.2-2'}}</td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="!invoiceData.items?.length" class="no-items">No items found in the invoice.</p>
    </div>

</div>

<p *ngIf="!invoiceData">No invoice data available.</p>